import { TimeZone } from './types/enums';
import type { UserData } from './types/UserData';

export const DEFAULT_NATIVE_VERSION = '1.0.0';

export const ROUTS_TRANSITION = 200;

export const XMOD_MAX_COMPONENT_INDEX = 10;

export const FWVERSION19TS = 20200827;
export const FWVERSION110TS = 20210318;

export const LOCAL_PATHS = ['images/room_def/', 'images/device_images/', 'images/home_def', 'hom_def'];

export const SLEEPING_TYPES = [
	'SHHT-1',
	'SHDW-1',
	'SHDW-2',
	'SHWT-1',
	'SHBTN-1',
	'SHBTN-2',
	'SHSM-01',
	'SNSN-0013A',
	'SNSN-0031Z',
	'S3SN-0082A', //Alarm bridge
	'S3SN-0U12A', //h&t g3,
	'S3SN-1U12A', //h&t g3 ffs,
	'S4SN-1031Z', //Heiman Smoke EU
	'S4SN-0031Z', //Heiman Smoke US
	'S4SN-0071A', //Flood gen 4
	'S4SN-0071Z', //Flood S gen 4
	'SMSN-0031ZL', //Smoke LTE
];

export const ALEXA_FFS_TYPES = ['SNPL-10112EU', 'S3PL-10112EU'];

export const HALF_SLEEPING_TYPES = ['SHMOS-01', 'SHMOS-02', 'SHTRV-01'];
export const GEN_ONE_TYPES_WITH_EXTERNAL_POWER = ['SHMOS-01', 'SHMOS-02', 'SHTRV-01', 'SHHT-1'];

export const MOTION_SENSOR_TYPES = ['SHMOS-01', 'SHMOS-02', 'SBMO-003Z', 'SBMO-103Z'];
export const GAS_SENSOR_TYPES = ['SHGS-1'];

export const NO_SWITCH_RESET = [
	'SHPLG-1',
	'SHPLG-S',
	'SHPLG-U1',
	'SHPLG-UK1',
	'SHPLG-AU1',
	'SHPLG-U1',
	'SHPLG2-1',
	'SHEM-3',
	'SHEM',
	'SHBTN-1',
	'SHBTN-2',
	'SHDW-2',
	'SHGS-1',
	'SHMOS-01',
	'SHMOS-02',
	'SHHT-1',
	'SHTRV-01',
	'SHWT-1',
	'SHCL-255',
	'SHBLB-1',
	'SHCB-1',
	'SHBDUO-1',
	'SHVIN-1',
	...SLEEPING_TYPES,
];

export const temp_sched_sensors = ['SHSEN-1', 'SHHT-1', 'SHDW-2', 'SHWT-1'];

export const FW_FOR_UPDATE = [
	'20190103-082948/rgbw2@565f4336',
	'20191219-100325/???',
	'20191216-140245/???',
	,
	'20191216-140157/???',
	'20181128-144724/???',
	'20191230-112953/master@fe7779a8+',
	'20191217-074901/1047-long-id-for-shelly-devices@ab2bdce7',
	'20190423-080637/v1.4.9-switch1pm-hotfix4@f8c51629',
];

//#region Device Minimum Versions

export const SUGGESTED_FW_UPDATE = {
	'S3SN-0U12A': '1.1.0',
	'S3SN-1U12A': '1.1.0',
};

/** Minimum firmware versions that trigger mandatory update (type 7). Resolved via getDeviceMinFwVersion(). */
export const FW_MIN_VERSION_GEN2_DEFAULT = '1.0.7';
/** Build date (YYYYMMDD) of FW_MIN_VERSION_GEN2_DEFAULT; used when fw_id has no semver segment. */
export const FW_MIN_VERSION_GEN2_DEFAULT_DATE = '20231031';
export const FW_MIN_VERSION_WALL_DISPLAY = '1.2.5';

export const FW_MIN_VERSION_DIFFUSER: Record<string, string> = {
	'S4PB-00CU000002': '2.0.0',
};

//#endregion Device Minimum Versions

export const LONG_ID_DEVICES_OTA = {
	'SGPLG-S': 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/plugs-longid.zip',
	'SHDM-1': 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/dimmer-longid.zip',
	'SHHT-1': 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/ht-longid.zip',
	'SHSW-1': 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/switch1-longid.zip',
	'SHSW-PM': 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/switch1pm-longid.zip',
	'SHSW-25': 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/switch25-longid.zip',
	SHEM: 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/em-longid.zip',
	SHRGBW2: 'http://shelly-api-eu.shelly.cloud/firmware/longid_patch/rgbw2-longid.zip',
};

export const TIMEZONE_LANG_MAP: Record<TimeZone, string> = {
	[TimeZone.Europe_Berlin]: 'de',
	[TimeZone.Europe_Rome]: 'it',
	[TimeZone.Europe_Lisbon]: 'pt',
	[TimeZone.Europe_Madrid]: 'es',
	[TimeZone.Europe_Paris]: 'fr',
	[TimeZone.Europe_Sofia]: 'bg',
	[TimeZone.Europe_Warsaw]: 'pl',
	[TimeZone.Europe_Prague]: 'cs',
	[TimeZone.Europe_Budapest]: 'hu',
	[TimeZone.Europe_Athens]: 'el',
	[TimeZone.Europe_Helsinki]: 'fi',
	[TimeZone.Europe_Stockholm]: 'sv-SE',
	[TimeZone.Europe_Copenhagen]: 'da',
	[TimeZone.Europe_Belgrade]: 'sr',
	[TimeZone.Europe_Tirane]: 'sq-AL',
	[TimeZone.Europe_Istanbul]: 'tr',
	[TimeZone.Europe_Moscow]: 'ru',
	[TimeZone.Asia_Tokyo]: 'ja-JP',
	[TimeZone.Asia_Seoul]: 'ko',
	[TimeZone.Asia_Shanghai]: 'zh-CN',
	[TimeZone.Asia_Hong_Kong]: 'zh-HK',
	[TimeZone.Asia_Jerusalem]: 'he',
	[TimeZone.Asia_Jakarta]: 'id-ID',
};

export const LANG_DICT = {
	en: 'English',
	bg: 'Български',
	cs: 'Čeština',
	da: 'Dansk',
	de: 'Deutsch',
	el: 'Ελληνικά',
	es: 'Español',
	fi: 'Suomi',
	fr: 'Français',
	he: 'עִברִית',
	hu: 'Magyar',
	'id-ID': 'Bahasa Indonesia',
	it: 'Italiano',
	'ja-JP': '日本',
	ko: '한국어',
	pl: 'Polski',
	pt: 'Português',
	ru: 'Русский',
	sl: 'Slovenščina',
	'sq-AL': 'Shqip',
	sr: 'Српски',
	'sr-Latn': 'Srpski',
	'sv-SE': 'Svenska',
	tr: 'Türkçe',
	'zh-CN': '简体中文',
	'zh-HK': '繁体中文',
};

export const DEVICE_ICONS_OLD = [
	'door',
	'emeter',
	'flood',
	'light',
	'motion',
	'relay',
	'roller',
	'sensor',
	'socket',
];

export const week_days = [
	{
		i18n: 'option_monday',
		short: 'M',
		middle: 'Mon',
		long: 'Monday',
		from_zero_ind: 0,
		from_one_ind: 1,
	},
	{
		i18n: 'option_tuesday',
		short: 'T',
		middle: 'Tue',
		long: 'Tuesday',
		from_zero_ind: 1,
		from_one_ind: 2,
	},
	{
		i18n: 'option_wednesday',
		short: 'W',
		middle: 'Wed',
		long: 'Wednesday',
		from_zero_ind: 2,
		from_one_ind: 3,
	},
	{
		i18n: 'option_thursday',
		short: 'Th',
		middle: 'Thu',
		long: 'Thursday',
		from_zero_ind: 3,
		from_one_ind: 4,
	},
	{
		i18n: 'option_friday',
		short: 'F',
		middle: 'Fr',
		long: 'Friday',
		from_zero_ind: 4,
		from_one_ind: 5,
	},
	{
		i18n: 'option_saturday',
		short: 'S',
		middle: 'Sat',
		long: 'Saturday',
		from_zero_ind: 5,
		from_one_ind: 6,
	},
	{
		i18n: 'option_sunday',
		short: 'S',
		middle: 'Sun',
		long: 'Sunday',
		from_zero_ind: 6,
		from_one_ind: 7,
	},
];

export const OPERATORS = [{ eq: 'equal' }, { gt: 'more_than' }, { lt: 'less_than' }];
// export const OPERATORS =  [{ui: 'less than', check: 'lt'}, {ui: "more than", check: 'gt'}];
export const TURN = [
	{ ui: 'on', check: 'on' },
	{ ui: 'off', check: 'off' },
];

export const INPUTS_READERS = [
	{ ui: 'short', check: 'S' },
	{ ui: 'long', check: 'L' },
	{ ui: 'double_short', check: 'SS' },
	{ ui: 'triple_short', check: 'SSS' },
	{ ui: 'short_long', check: 'SL' },
	{ ui: 'long_short', check: 'LS' },
];

// export const INPUTS_READER_COUNTER =  [
//     {ui: 'one time pressed', check: 1},
//     {ui: 'two times pressed',check :2},
//     {ui:  "tree times", check: 3}
// ];

export const DOOR_STATE = [
	{ ui: 'close', check: 'off' },
	{ ui: 'open', check: 'on' },
];

// export const LUX = [ {ui: "DARK", check: 'DARK'}, {ui: "LIGHT", check: "LIGHT"}];

export const SENSOR_DETECTION = [
	{ ui: 'detected', check: 'true' },
	{ ui: 'not detected', check: 'false' },
];

export const MOTION_DETECTION = [
	{ ui: 'detected', check: 'on' },
	{ ui: 'not detected', check: 'off' },
];

export const COLOR_BULBS = ['SHCL-255', 'SHBLB-1', 'SHCB-1', 'SHRGBWW-01'];

export const MODULES = ['S3MX-0A', 'S3XT-0S'];

export const CCT_ONLY_DEVICES = ['S3BL-D010009AEU', 'S3PB-04F7045601'];

export const NO_CHANNELS_GEN_1_DEVICES = [
	'SHHT-1',
	'SHBTN-1',
	'SHBTN-2',
	'SHWT-1',
	'SHDW-1',
	'SHDW-2',
	'SHCL-255',
	'SHBLB-1',
	'SHCB-1',
	'SHMOS-01',
	'SHMOS-02',
	'SHTRV-01',
	'S3SN-0U12A',
	'S3SN-1U12A',
	'SHPLG2-1',
	'SHPLG-S',
	'SHVIN-1',
	'SHGS-1',
];

export const ONE_CHANNEL_GEN_1_DEVICES = [
	'SHSW-PM',
	'SHSW-1',
	'SHSW-L',
	'SHDM-1',
	'SHDM-2',
	'SHRGBWW-01',
	'SHEM-3',
];

export const QUICK_TIME_CONTROL_CORRECTION_GEN_1_DEVICES = [
	'SHDM-1',
	'SHDM-2',
	'SHVIN-1',
	'SHCL-255',
	'SHBLB-1',
	'SHCB-1',
	'SHRGBW2',
	'SHBDUO-1',
];

export const DEVICE_NAME_SYS_SYNC_GEN_2_DEVICES = [
	'SNSN-0013A',
	'SNSN-0031Z',
	'S3SN-0082A',
	'SNGW-ZW01',
	'S3SN-0U12A',
	'S3SN-1U12A',
];

export const DEVICES_WITH_CYCLE_INPUT_MODE = [
	'SPSW-002XE16EU',
	'SPSH-002PE16EU',
	'SPSH-102PE16EU',
	'SPSW-002PE16EU',
	'SPSW-102PE16EU',
	'SPSW-202PE16EU',
	'SPSW-202PE12UL',
	'SNSW-102P16EU',
	'SNSW-002P16EU',
	'S3SW-002P16EU', // 2PM Gen3
	'S4SW-002P16EU', // 2PM Gen4
];

export const DEVICES_COVER_SWITCH_TYPES = [
	'S3SW-002P16EU', // '2 PM G3
	'S4SW-002P16EU', // '2 PM G4
	'SNSW-102P16EU', // Plus 2 PM (gen 2)
	'SPSW-002PE16EU', // Pro 2 PM
	'SPSW-102PE16EU', // Pro 2 PM
	'SPSW-202PE16EU', // Pro 2 PM
	'SPSW-202PE12UL', // Pro 2 PM
	'SPSW-002XE16EU', // Pro 2
	'SNSW-002P16EU', // Plus 2 PM
	'SPSH-002PE16EU', // Pro 2 Cover G2
	'SPSH-102PE16EU', // Pro 2 Cover G4
	'SHSW-21', // shellyswitch21
	'SHSW-25', // shellyswitch25 // 2.5
	'S3SH-0A2P4EU', // shutter
];

export const APPLIANCE_TYPES_VALUES = {
	unknown: 0,
	light: 2,
	entertainment: 3,
	heating: 4,
	refrigeration: 5,
	laundry_cleaning: 6,
	cooking: 7,
	pool: 8,
	electric_vehicle: 9,
	ventilation: 10,
	water_heater: 13,
	other: 14,
	roller: 15,
	garage_door: 16,
	game_console: 17,
	computer: 18,
	speaker_system: 19,
	projector: 20,
};

export const USER_DATA_DEFAULT: UserData = {
	email: '',
	password: '',
	lang: 'en',
	premium: 0,
	regts: 0,
	token: '',
	user_id: '',
	timezone: '',
	lock_pin: '',
	user_api_url: '',
	notifications_urls: [],
	refresh_token: '',
	notifications_data: {
		hosts: [],
		pathname: '/shelly/wss/hk_sock',
		port: 6113,
		protocol: 'wss:',
	},
	test_user: false,
};

/**
 * actions filter constants
 * //when device returns all, but we need specific
 * - (SHSW-25 in both modes needs filter)
 * - 1, 1PM, UNI -> remove external sensors' actions when get I/O
 */
export const EXT_TEMP = ['ext_temp_over_url', 'ext_temp_under_url'];
export const EXT_HUM = ['ext_hum_over_url', 'ext_hum_under_url'];
export const REMOVE_WHEN_ROLLER = [
	'btn_on_url',
	'btn_off_url',
	'out_on_url',
	'out_off_url',
	'longpush_url',
	'shortpush_url',
];
export const REMOVE_ROLLER_WHEN_RELAY = ['roller_open_url', 'roller_close_url', 'roller_stop_url'];

export const DEVICES_WITH_MODE_CHANGE = [
	'SHSW-25',
	'SHRGBW2',
	'SNSW-102P16EU',
	'SPEM-003CEBEU',
	'EFPEM-003CEBEU120',
	'SPSW-002XE16EU',
	'SPSW-002PE16EU',
	'SPSW-202PE16EU',
	'S3SW-002P16EU',
	'SNDC-0D4P10WW',
];

export const EXTERNAL_SENSOR_ACTIONS = [...EXT_HUM, ...EXT_TEMP];
export const ADC_ACTIONS = ['adc_over_url', 'adc_under_url'];

export const RELAY_LIGHT_CONTROL = ['SHSW-1', 'SHSW-21', 'SHSW-22', 'SHSW-25', 'SHSW-44'];

export const TEMPERATURE_SENSORS = [
	'SHSEN-1',
	'SHHT-1',
	'SHDW-2',
	'SHWT-1',
	'SNSN-0013A',
	'SHMOS-02',
	'SAWD-0A1XX10EU1',
	'SHTRV-01',
	'S3SN-0U12A', //h&t g3
	'S3SN-1U12A', //h&t g3 ffs
	'SBHT-003C', //h&t bt
	'SBHT-103C', //h&t bt display https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2846
	'SBHT-203C', //h&t bt zb
	'SBWS-90CM', // Weather station
	'SBMS-001A', // Blu Soil Sensor
];

export const TEMPERATURE_SENSORS_IN_CELSIUS = [
	'SBHT-003C', // h&t bt
	'SBHT-103C', // h&t bt display https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2846
	'SBHT-203C', // h&t bt zb
	'SBTR-001AEU', // BLU TRV
	'SBWS-90CM', // Weather station
	'SBMS-001A', // Blu Soil Sensor
];

export const HUMIDITY_SENSORS = ['SHSEN-1', 'SHHT-1', 'SHWT-1'];

export const DOOR_SENSORS = ['SHDW-2'];

export const DEVICE_MAX_POWER_DEFAULTS = {
	'SHSW-21': 1840,
	'SHSW-25': 2300,
	'SHSW-25-US': 1200,
	'SHSW-44': 2300,
	'SHPLG-1': 3500,
	'SHPLG-S': 2500,
	'SHPLG-AU1': 2500,
	'SHPLG-IT1': 2500,
	'SHPLG-UK1': 2500,
	'SHPLG-U1': 1800,
	'SHSW-PM': 3500,
	'SHSW-PM-US': 1800,
	'SHPLG2-1': 3500,
	SHEM: 26000, //ilian kaza :D
	'SHEM-3': 26000, //ilian kaza :D
	SHPSW04P: 3500,
	'SNPL-00110EU': 2500,
	'SNPL-00210EU': 2500,
	'SNPL-00112EU': 2500, // Alex: discussed with @a.krustev, this is the value displayed on the box. Firmware is adapted do validate with this value after version 0.13.0.
	'SNPL-10112EU': 2500,
	'S3PL-10112EU': 2500,
	'S3PL-00112EU': 2500,
	'S3PL-30110EU': 3000,
	'S3PL-00115US': 1800,
	'S3PL-00110CN': 2500,
	'EF3PL-00112EU': 2500,
	'S4PL-00416EU': 3360,
	'S4PL-00415US': 1800,
	'S3PL-20112EU': 2500,
	'S3PL-30116EU': 2500,
	'SNPL-00116US': 4480,
	'S4PL-00116US': 1800,
	'SNPL-00116IT': 4480,
	'SNPL-00110IT': 2300,
	'SNSW-001P15UL': 4480,
	'SNSW-001P16EU': 4480,
	'SNSW-002P16EU': 2800,
	'SNSW-102P16EU': 2800,
	'SPSW-001PE16EU': 4480,
	'SPSW-001PE40EU': 9000, // Pro 1PM 40A Gen4
	'SPSW-101PE16EU': 4480,
	'SPSW-201PE16EU': 4480,
	'SPSW-002PE16EU': 4480,
	'SPSW-102PE16EU': 4480,
	'SPSW-202PE16EU': 4480,
	'SPSW-202PE16UL': 4480,
	'SPSW-004PE16EU': 4480,
	'SPSW-104PE16EU': 4480,
	'SPSW-202PE12UL': 2500, // Shelly PRO 2 PM UL
	'SNSW-001P8EU': 2240,
	'S4SW-001P8EU': 2240,
	'S3SW-001P8EU': 2240,
	'S4SW-001P16EU': 4480,
	'SPSH-002PE16EU': 4480, // Pro 2 Cover G2
	'SPSH-102PE16EU': 4480, // Pro 2 Cover G4
	'SPDM-001PE01EU': 230,
	'SPDM-002PE01EU': 230,
	'SPCC-001PE10EU': 4480, //ShellyPro0110PM
	'S3SW-001P16EU': 4480,
	'S3SW-001P16SP': 4480,
	'S3SW-002P16EU': 2800,
	'S3SH-0A2P4EU': 2800,
	'S4SW-002P16EU': 2800,
	'SPDC-0D5PE16EU': 350, // Pro RGBWW PM
	'S3DM-0A101WWL': 240, // Shelly Dimmer Gen3
	'S4DM-0A101WWL': 240, // Shelly Dimmer Gen4
	'S4DM-0A102US': 220, // Shelly Dimmer Gen4 US
	'SNPL-00112UK': 3000, // Shelly Plus Plug UK
	'EFNPL-00112UK': 3000, // EcoFlow Plug UK
	'S3PB-O3AR000001': 7000, // Ogemray
	'SPSW-204PE16EU': 4480, // Shelly Pro 4PM Gen4
	'S4PL-00114EU': 3220, //Shelly Plug C Gen4
}; //this is used for power protection

export const DEVICE_MAX_CURRENT_DEFAULTS = {
	'SNPL-00110EU': 10,
	'SNPL-00112EU': 12,
	'SNPL-10112EU': 12,
	'S3PL-10112EU': 12,
	'S3PL-00112EU': 12,
	'S3PL-30110EU': 13,
	'S3PL-00115US': 15,
	'S3PL-00110CN': 12,
	'EF3PL-00112EU': 12,
	'S3PL-30116EU': 16,
	'S4PL-00416EU': 12,
	'S4PL-00415US': 15,
	'S3PL-20112EU': 12,
	'SNPL-00116US': 16,
	'S4PL-00116US': 15,
	'SNPL-00116IT': 16,
	'SNPL-00110IT': 10,
	'SNSW-001P15UL': 16,
	'SNSW-001P16EU': 16,
	'SNSW-002P16EU': 10,
	'SNSW-102P16EU': 10,
	'SPSW-001PE16EU': 16,
	'SPSW-001PE40EU': 40,
	'SPSW-101PE16EU': 16,
	'SPSW-201PE16EU': 16,
	'SPSW-002PE16EU': 16,
	'SPSW-102PE16EU': 16,
	'SPSW-202PE16EU': 16,
	'SPSW-202PE16UL': 16,
	'SPSW-004PE16EU': 16,
	'SPSW-104PE16EU': 16,
	'SPSW-202PE12UL': 12,
	'SNSW-001P8EU': 8,
	'S4SW-001P8EU': 8,
	'S4SW-001P16EU': 16,
	'SPSH-002PE16EU': 16, // Pro 2 Cover G2
	'SPSH-102PE16EU': 16, // Pro 2 Cover G4
	'SPDM-001PE01EU': 1.22,
	'SPDM-002PE01EU': 1.22,
	'SNDC-0D4P10WW': 10, //plus rgbw rgb and rgbw profiles
	'SNDC-0D4P10WWL': 4, //plus rgbw light profile
	'SPCC-001PE10EU': 16, //ShellyPro0110PM
	'S3SW-002P16EU': 10, //Shelly 2PM G3 S3SW-002P16EU
	'S3SH-0A2P4EU': 10, //Shelly Shutter
	'S4SW-002P16EU': 10, //Shelly 2PM G4 S4SW-002P16EU
	'SPDC-0D5PE16EU': 6, // Pro RGBWW PM
	'S3DM-0A101WWL': 1.2, // Dimmer Gen3
	'S4DM-0A101WWL': 1.2, // Dimmer Gen4
	'S4DM-0A102US': 2.2, // Shelly Dimmer Gen4 US
	'SNPL-00112UK': 13, // Shelly Plus Plug UK
	'EFNPL-00112UK': 13, // EcoFlow Plug UK
	'S3PB-O3AR000001': 25, // Ogemray
	'S3SW-001P8EU': 8, //Shelly 1PM Mini G3
	'SPSW-204PE16EU': 16, //Shelly 2PM G3 SPSW-204PE16EU
	'S4PL-00114EU': 14, //Shelly Plug C Gen4
};

export const LIGHTS_WITH_HIGH_VOLTAGE_PROTECTION = [
	'SPDM-001PE01EU', //Shelly Pro Dimmer 1PM
	'SPDM-002PE01EU', // Shelly Pro Dimmer 2PM
	'S3DM-0A101WWL', // Dimmer Gen3
	'S4DM-0A101WWL', // Dimmer Gen4
	'S4DM-0A102US', // Shelly Dimmer Gen4 US
	'SPCC-001PE10EU', // ShellyPro0110PM
];

export const DEVICES_UNDER_VOLTAGE_PROTECTION = {
	'S3DM-0A101WWL': 100, // Dimmer Gen3
	'S4DM-0A101WWL': 100, // Dimmer Gen4
	'S4DM-0A102US': 100, // Shelly Dimmer Gen4 US
};

export const DEVICES_DIMMER_VOLTAGE_PROTECTION = {
	'S3DM-0A101WWL': {
		// Dimmer Gen3 — undervoltage >= 100 && <= 280; overvoltage > 100 && <= 280
		undervoltage: { min: 100, max: 280 },
		overvoltage: { min: 101, max: 280 },
	},
	'S4DM-0A101WWL': {
		// Dimmer Gen4 — same as Gen3
		undervoltage: { min: 100, max: 280 },
		overvoltage: { min: 101, max: 280 },
	},
	'S4DM-0A102US': {
		// Shelly Dimmer Gen4 US — undervoltage >= 80 && < 150; overvoltage > 80 && <= 150
		undervoltage: { min: 80, max: 149 },
		overvoltage: { min: 81, max: 150 },
	},
};

export const DEFAULT_DIMMER_VOLTAGE_LIMITS = DEVICES_DIMMER_VOLTAGE_PROTECTION['S3DM-0A101WWL'];

export const DEVICES_WITH_MAX_VOLTAGE_PROTECTION = {
	'S4PL-00116US': 150, // plug us
	'S3PL-00115US': 150, // plug m us gen3
	'S4PL-00415US': 150, // Power Strip 4 US Gen4
	'S3PL-30110EU': 280, // plug m
};

export const DIMMERS_WITH_CALIBRATION = [
	'S3DM-0A101WWL', // Dimmer Gen3
	'S4DM-0A101WWL', // Dimmer Gen4
	'S4DM-0A102US', // Shelly Dimmer Gen4 US
];

// dimmers with calibration from v.1.6.0 and above
export const PRO_DIMMERS_WITH_CALIBRATION = [
	'SPDM-002PE01EU', // Pro Dimmer 2PM
	'SPDM-001PE01EU', //  Pro Dimmer 1PM
];

export const ZENDURE_MODELS = [
	'XPZ-SOLARFLOW',
	'XPZ-SOLARFLOW1200',
	'XPZ-SOLARFLOW2000',
	'XPZ-AIO2400',
	'XPZ-HYPER2000',
	'XPZ-ACE1500',
	'XPZ-HUB1200',
];

export const BLE_BUTTON_MODELS = [
	'SBBT-002C', // Shelly BLU Button
	'SBBT-102C', // Shelly BLU Button Tough 1 ZB
	'SBBT-102CEU', // Shelly BLU Wall Switch 2 ZB
	'SBBT-004C', // Shelly BLU Button 4
	'SBBT-004CUS', // Shelly BLU Button 4 US
	'SBBT-004CEU', // Shelly BLU Button 4 EU
	'SBBT-104CUS', // Shelly BLU Button 4 US ZB
	'SBBT-104CEU', // Shelly BLU Button 4 EU ZB
];

export const BLE_BUTTONS_WITH_4_INPUTS = [
	'SBBT-004C', // Shelly BLU Button 4
	'SBBT-004CUS', // Shelly BLU Button 4 US
	'SBBT-004CEU', // Shelly BLU Button 4 EU
];

export const BLE_DEVICES_ZB = [
	'SBBT-102C', // Shelly BLU Button Tough 1 ZB
	'SBBT-102CEU', // Shelly BLU Wall Switch 2 ZB
	'SBBT-104CEU', // Shelly BLU Button 4 EU ZB
	'SBBT-104CUS', // Shelly BLU Button 4 US ZB
	'SBDW-103C', // Shelly BLU Door Window ZB
	'SBDW-203C', // Shelly BLU Door Window Mini ZB
	'SBDW-302C', // Shelly BLU Door Window Outdoor ZB
	'SBHT-103C', // Shelly BLU HT Display ZB
	'SBHT-203C', // Shelly BLU HT ZB
	'SBMO-103Z', // Shelly BLU Motion ZB
	'SBRC-005B', // Shelly BLU Remote Control ZB
	'SBRK-002C', // Shelly BLU Rotary Knob ZB
];

export const PROTOTYPES = [
	'PLG1NB',
	'SMK1NB',
	'DS1NB',
	'MS1NB',
	'HT1NB',
	'WS1NB',
	'IR_REM-0',
	'IR_REM-1-remote',
	'SHSPOT-1',
	'SHPSW04P',
	'SH2LED-1',
	'SHSW-22',
	'SHDIMW-1',
	'SHPLG-U1',
	'SHRGBWW-01',
	'SPSW-001PE40EU', // TODO: (R.K) remove once this is released as a production model
	...ZENDURE_MODELS,
	// Cameras
	'SACM-0A0XX0EU0', // Shelly Android Camera
	// 'S1CM-0DXW00', // Shelly Camera
]; // used to hide discontinued or prototype devices from IOS inclusion.

/* BLE devices are hidden from the AP inclusion,
 * but they are not prototypes, so they are not included in the PROTOTYPES constant.
 * Newly incommign devices are added here as well.
 * TODO: Refactor the daming of all those constants and separate them in a better way.
 */
export const TEST_DEVICES = [
	// BLU devices are hidden form the ap inclusion, so it was easier to filer them out along with these
	'SBDW-002C', // Shelly BLU Door Window
	'SBDW-103C', // Shelly BLU Door Window ZB
	'SBDW-203C', // Shelly BLU Door Window Outdoor ZB
	'SBHT-003C', // Shelly BLU H&T
	'SBHT-103C', // Shelly BLU H&T Display https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2846
	'SBHT-203C', // Shelly BLU H&T ZB
	'SBDS-002A', // Shelly BLU Distance
	'SBBT-002C', // Shelly BLU Button
	'SBBT-102C', // Shelly BLU Button Tough 1 ZB
	'SBBT-102CEU', // Shelly BLU Wall Switch 2 ZB
	'SBMO-003Z', // Shelly BLU Motion
	'SBBT-004C', // Shelly BLU Button 4
	'SBBT-004CUS', // Shelly BLU Button 4 US
	'SBBT-004CEU', // Shelly BLU Button 4 EU
	'SBBT-104CUS', // Shelly BLU Button 4 EU ZB
	'SBBT-104CEU', // Shelly BLU Button 4 US ZB
	'SBWS-90CM', // Shelly Weather Station

	'SNSL-0A1X03WWL',
	'SNSL-0A2X03WWL',
	'SAWD-0A1XX10EU1',
	'SAWD-1A1XX10EU1',
	'SAWD-2A1XX10EU1', //ShellyWallDisplayX2
	'SAWD-3A2XE10EU2', //ShellyWallDisplayXL old model
	'SAWD-3A1XE10EU2', //ShellyWallDisplayXL new model
	'SAWD-4A1XE10US0', //ShellyWallDisplayXL US
	'SAWD-5A1XX10EU0', //ShellyWallDisplayX2 Smatek
	'SAWD-6A1XX10EU0', //ShellyWallDisplayX1i
	'SAWD-6A0XX0EU0', //ShellyWallDisplay D1
	'SNDM-9995WW',
	'SNGW-ZW01',
	'S3GW-1DZW0EU',
	'S3BL-C010007AEU',
	'S3BL-D010009AEU',
	'S3XT-0S', // module XT1
	'S3MX-0A', // module XMOD1
	'S3SN-1U12A', // HnT FFS https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1574
	// 'S3PB-O3AR000001', // https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1756
	// 'S3EM-002CXCEU', // https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1581
	'S3EM-003CXCEU63', // https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1701
	'S4EM-003RXCEU63', // https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1701
	'SBTR-001AEU', // blue trv can not be added by AP - https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1793

	// gen4 device - soon to be removed from here
	'S4SN-0A24X', //shelly i4 gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1993
	'S4SN-0D24X', //shelly i4DC gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2606
	'S4EM-001PXCEU16', //shelly em mini gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2045
	'S4EM-001CXCEU63', //shelly em-63 gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/3138
	'S4SN-0071Z', // Shelly Flood S Gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/3076

	'SPCB-01VENEU', // shelly pro cb
	'SPCB-02VENEU', // shelly pro cb
	'SPCB-03VENEU', // shelly pro cb
	'SPCB-04VENEU', // shelly pro cb https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1996
	'S3GW-0D4G0EU', // Shelly 4G Gateway https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2049
	'LOQED', // Loqed
	'S3PB-04F7045601', //Hilux https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2358
	'S4SW-0A1X1EUL', // Shelly 1L Gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2392
	'S4SW-0A2X4EUL', // Shelly 2L Gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2153
	'SBRC-005B', // Shelly BLU Remote Controler https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2519
	'SBRK-002C', // Shelly BLU Rotary Knob ZB

	// Missed to be excluded from the lists
	// https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2728
	'S4SN-0U61X', //Shelly Presence
	'S4PB-0916176901', // MMotors Ventora
	'S3SN-0082A', // Alarm Bridge
	'S3SW-0A1X5US', // Wall switch Single Pole
	'S4SN-0A61X', // Presence C Gen4
	'SBMS-001A', // BLU Soil
	'SPSW-001PE40EU', //Shelly Pro 1PM 40A Gen4
	'S3SW-001P16SP', //Simone 1PM
	'SNSW-002X16EU', //Shelly Plus 2
	// Cameras
	'SACM-0A0XX0EU0', // Shelly Android Camera
	'S1CM-0DXW00', // Shelly Camera

	// service device names
	'virtual-group',
	'peripheral-device',
];

export const NEW_HOOKS = [
	'SNSN-0013A',
	'SAWD-0A1XX10EU1',
	'SAWD-2A1XX10EU1',
	'S3SN-0U12A',
	'S3SN-1U12A',
]; //plain to use this for new webhooks gen 2//adding new h&t

/*
 * set devices with multiple images taht can be selected
 * first image should aways be the default one with the default device type/model
 */
export const MULTIPLE_IMAGES = [
	'SHVIN-1',
	'SHVIN-1-A60',
	'SHVIN-1-ST64',
	// hnt 1
	'SHHT-1',
	'SHHT-1-B',
	// ble button
	'SBBT-002C-Whi',
	'SBBT-002C-Bla',
	'SBBT-002C-Red',
	'SBBT-002C-Blu',
	'SBBT-002C-T-Ivr',
	'SBBT-002C-T-Moch',
	'SBBT-002C',
	// ble button ZB
	'SBBT-102C-T-Ivr',
	'SBBT-102C-T-Moch',
	'SBBT-102C',
	// plus plug
	'SNPL-00110EU',
	'SNPL-00110EU-B',
	// hnt 3
	'S3SN-0U12A',
	'S3SN-0U12A-Cr1',
	'S3SN-0U12A-Cr2',
	'S3SN-0U12A-Bla',
	'S3SN-1U12A', //ht ge ffs maybe will have multiple images
	// ble hnt
	'SBHT-003C',
	'SBHT-003C-Ivr',
	'SBHT-003C-Moch',
	// ble ht display
	'SBHT-103C',
	'SBHT-103C-Black',
	// ble hnt zb
	'SBHT-203C',
	'SBHT-203C-Ivr',
	'SBHT-203C-Moch',
	//plug us
	'S4PL-00116US',
	'S4PL-00116US-Bla',
	'S3PL-00115US',
	'S3PL-00115US-Bla',
	//power strip gen4
	'S4PL-00415US',
	'S4PL-00415US-Bla',
	//plug eu
	'S4PL-00116EU',
	'S4PL-00116EU-Bla',
	'S4PL-00114EU',
	'S4PL-00114EU-Bla',
	//blu remote controler
	'SBRC-005B',
	'SBRC-005B-Whi',
	// shelly presence
	'S4SN-0U61X',
	'S4SN-0U61X-Black',
	//shelly plug M
	'S3PL-30110EU',
	'S3PL-30110EU-Bla',
	//zb blue door mini and outdoor
	'SBDW-203C',
	'SBDW-203C-Black',
	'SBDW-203C-Bro',
	'SBDW-302C',
	'SBDW-302C-Black',
	'SBDW-302C-Moch',
	// shelly camera
	'S1CM-0DXW00',
	'S1CM-0DXW00-Bla',
];

//this constant will include gen2 devices with newly created profiles like PlusRGBW for example. Inside devices_settings[device.id].DeviceInfo.profile
export const PROFILE_DEVICES = [
	'SNDC-0D4P10WW', // Plus RGBW PM has profiles: RGB, RGBW and light profiles
	'SPDC-0D5PE16EU', // PRO RGBWW PM has profiles: cctx2, light, rgbcct, rgbx2light
]; //temporary decision for pro dimmers gen 2 to get mode, must be reworked!

export const DIMMERS_WITH_MULTIPLE_INPUTS = [
	'SNDM-00100WW', //Shelly Plus 0-10V Dimmer Dimmer
	'SPDM-001PE01EU', // Shelly Pro Dimmer 1PM
	'SPDM-002PE01EU', // Shelly Pro Dimmer 2PM
	'S3DM-0010WW', // Shelly Dimmer 0/1-10V PM Gen3
	'S3DM-0A101WWL', // Shelly Dimmer Gen3
	'S4DM-0A101WWL', // Shelly Dimmer Gen4
	'S4DM-0A102US', // Shelly Dimmer Gen4 US
	'S4DM-0010WW', // Shelly Dimmer 0/1-10V PM Gen4
	'SBDW-203C', // Shelly BLU Door Window Mini ZB
	'SBDW-302C', // Shelly BLU Door Window Outdoor ZB
];

export const PM_DEVICES_WITH_TWO_INPUTS_IN_COVER_MODE = [
	'SNSW-002P16EU',
	'SNSW-102P16EU',
	'SPSW-002PE16EU',
	'SPSW-102PE16EU',
	'SPSW-202PE12UL',
	'SPSW-202PE16EU',
	'S3SW-002P16EU',
	'S4SW-002P16EU',
];

export const DIMMERS_WITH_TWO_INPUTS = ['S3DM-0010WW', 'S4DM-0010WW', 'SNDM-00100WW'];

export const CURRENCIES = [
	{
		CurrencyCode: 'AED',
		CurrencyName: 'United Arab Emirates Dirham',
	},
	{
		CurrencyCode: 'ARS',
		CurrencyName: 'Argentine Peso',
	},
	{
		CurrencyCode: 'AUD',
		CurrencyName: 'Australian Dollar',
	},
	{
		CurrencyCode: 'BDT',
		CurrencyName: 'Bangladeshi Taka',
	},
	{
		CurrencyCode: 'BGN',
		CurrencyName: 'Bulgarian Lev',
	},
	{
		CurrencyCode: 'BHD',
		CurrencyName: 'Bahraini Dinar',
	},
	{
		CurrencyCode: 'BND',
		CurrencyName: 'Brunei Dollar',
	},
	{
		CurrencyCode: 'BOB',
		CurrencyName: 'Bolivian Boliviano',
	},
	{
		CurrencyCode: 'BRL',
		CurrencyName: 'Brazilian Real',
	},
	{
		CurrencyCode: 'BWP',
		CurrencyName: 'Botswanan Pula',
	},
	{
		CurrencyCode: 'BYN',
		CurrencyName: 'Belarusian Ruble',
	},
	{
		CurrencyCode: 'CAD',
		CurrencyName: 'Canadian Dollar',
	},
	{
		CurrencyCode: 'CHF',
		CurrencyName: 'Swiss Franc',
	},
	{
		CurrencyCode: 'CLP',
		CurrencyName: 'Chilean Peso',
	},
	{
		CurrencyCode: 'CNY',
		CurrencyName: 'Chinese Yuan',
	},
	{
		CurrencyCode: 'COP',
		CurrencyName: 'Colombian Peso',
	},
	{
		CurrencyCode: 'CRC',
		CurrencyName: 'Costa Rican Colón',
	},
	{
		CurrencyCode: 'CZK',
		CurrencyName: 'Czech Koruna',
	},
	{
		CurrencyCode: 'DKK',
		CurrencyName: 'Danish Krone',
	},
	{
		CurrencyCode: 'DOP',
		CurrencyName: 'Dominican Peso',
	},
	{
		CurrencyCode: 'DZD',
		CurrencyName: 'Algerian Dinar',
	},
	{
		CurrencyCode: 'EGP',
		CurrencyName: 'Egyptian Pound',
	},
	{
		CurrencyCode: 'EUR',
		CurrencyName: 'Euro',
	},
	{
		CurrencyCode: 'FJD',
		CurrencyName: 'Fijian Dollar',
	},
	{
		CurrencyCode: 'GBP',
		CurrencyName: 'British Pound Sterling',
	},
	{
		CurrencyCode: 'GEL',
		CurrencyName: 'Georgian Lari',
	},
	{
		CurrencyCode: 'GHS',
		CurrencyName: 'Ghanaian Cedi',
	},
	{
		CurrencyCode: 'HKD',
		CurrencyName: 'Hong Kong Dollar',
	},
	{
		CurrencyCode: 'HRK',
		CurrencyName: 'Croatian Kuna',
	},
	{
		CurrencyCode: 'HUF',
		CurrencyName: 'Hungarian Forint',
	},
	{
		CurrencyCode: 'IDR',
		CurrencyName: 'Indonesian Rupiah',
	},
	{
		CurrencyCode: 'ILS',
		CurrencyName: 'Israeli New Sheqel',
	},
	{
		CurrencyCode: 'ISK',
		CurrencyName: 'Icelandic Króna',
	},
	{
		CurrencyCode: 'INR',
		CurrencyName: 'Indian Rupee',
	},
	{
		CurrencyCode: 'IQD',
		CurrencyName: 'Iraqi Dinar',
	},
	{
		CurrencyCode: 'JOD',
		CurrencyName: 'Jordanian Dinar',
	},
	{
		CurrencyCode: 'JPY',
		CurrencyName: 'Japanese Yen',
	},
	{
		CurrencyCode: 'KES',
		CurrencyName: 'Kenyan Shilling',
	},
	{
		CurrencyCode: 'KRW',
		CurrencyName: 'South Korean Won',
	},
	{
		CurrencyCode: 'KWD',
		CurrencyName: 'Kuwaiti Dinar',
	},
	{
		CurrencyCode: 'KZT',
		CurrencyName: 'Kazakhstani Tenge',
	},
	{
		CurrencyCode: 'LBP',
		CurrencyName: 'Lebanese Pound',
	},
	{
		CurrencyCode: 'LKR',
		CurrencyName: 'Sri Lankan Rupee',
	},
	{
		CurrencyCode: 'LTL',
		CurrencyName: 'Lithuanian Litas',
	},
	{
		CurrencyCode: 'MAD',
		CurrencyName: 'Moroccan Dirham',
	},
	{
		CurrencyCode: 'MDL',
		CurrencyName: 'Moldovan Leu',
	},
	{
		CurrencyCode: 'MMK',
		CurrencyName: 'Myanma Kyat',
	},
	{
		CurrencyCode: 'MOP',
		CurrencyName: 'Macanese Pataca',
	},
	{
		CurrencyCode: 'MUR',
		CurrencyName: 'Mauritian Rupee',
	},
	{
		CurrencyCode: 'MXN',
		CurrencyName: 'Mexican Peso',
	},
	{
		CurrencyCode: 'MKD',
		CurrencyName: 'Macedonian Denar',
	},
	{
		CurrencyCode: 'MYR',
		CurrencyName: 'Malaysian Ringgit',
	},
	{
		CurrencyCode: 'NAD',
		CurrencyName: 'Namibian Dollar',
	},
	{
		CurrencyCode: 'NGN',
		CurrencyName: 'Nigerian Naira',
	},
	{
		CurrencyCode: 'NIO',
		CurrencyName: 'Nicaraguan Córdoba',
	},
	{
		CurrencyCode: 'NOK',
		CurrencyName: 'Norwegian Krone',
	},
	{
		CurrencyCode: 'NPR',
		CurrencyName: 'Nepalese Rupee',
	},
	{
		CurrencyCode: 'NZD',
		CurrencyName: 'New Zealand Dollar',
	},
	{
		CurrencyCode: 'OMR',
		CurrencyName: 'Omani Rial',
	},
	{
		CurrencyCode: 'PEN',
		CurrencyName: 'Peruvian Nuevo Sol',
	},
	{
		CurrencyCode: 'PHP',
		CurrencyName: 'Philippine Peso',
	},
	{
		CurrencyCode: 'PKR',
		CurrencyName: 'Pakistani Rupee',
	},
	{
		CurrencyCode: 'PLN',
		CurrencyName: 'Polish Zloty',
	},
	{
		CurrencyCode: 'PYG',
		CurrencyName: 'Paraguayan Guarani',
	},
	{
		CurrencyCode: 'QAR',
		CurrencyName: 'Qatari Rial',
	},
	{
		CurrencyCode: 'RON',
		CurrencyName: 'Romanian Leu',
	},
	{
		CurrencyCode: 'RSD',
		CurrencyName: 'Serbian Dinar',
	},
	{
		CurrencyCode: 'RUB',
		CurrencyName: 'Russian Ruble',
	},
	{
		CurrencyCode: 'SAR',
		CurrencyName: 'Saudi Riyal',
	},
	{
		CurrencyCode: 'SEK',
		CurrencyName: 'Swedish Krona',
	},
	{
		CurrencyCode: 'SGD',
		CurrencyName: 'Singapore Dollar',
	},
	{
		CurrencyCode: 'SVC',
		CurrencyName: 'Salvadoran Colón',
	},
	{
		CurrencyCode: 'THB',
		CurrencyName: 'Thai Baht',
	},
	{
		CurrencyCode: 'TTD',
		CurrencyName: 'Trinidad and Tobago Dollar',
	},
	{
		CurrencyCode: 'TND',
		CurrencyName: 'Tunisian Dinar',
	},
	{
		CurrencyCode: 'TRY',
		CurrencyName: 'Turkish Lira',
	},
	{
		CurrencyCode: 'TWD',
		CurrencyName: 'New Taiwan Dollar',
	},
	{
		CurrencyCode: 'TZS',
		CurrencyName: 'Tanzanian Shilling',
	},
	{
		CurrencyCode: 'UAH',
		CurrencyName: 'Ukrainian Hryvnia',
	},
	{
		CurrencyCode: 'UGX',
		CurrencyName: 'Ugandan Shilling',
	},
	{
		CurrencyCode: 'USD',
		CurrencyName: 'US Dollar',
	},
	{
		CurrencyCode: 'UYU',
		CurrencyName: 'Uruguayan Peso',
	},
	{
		CurrencyCode: 'UZS',
		CurrencyName: 'Uzbekistan Som',
	},
	{
		CurrencyCode: 'VEF',
		CurrencyName: 'Venezuelan Bolívar (2008-2018)',
	},
	{
		CurrencyCode: 'VES',
		CurrencyName: 'Venezuelan Bolívar',
	},
	{
		CurrencyCode: 'VND',
		CurrencyName: 'Vietnamese Dong',
	},
	{
		CurrencyCode: 'XOF',
		CurrencyName: 'CFA Franc BCEAO',
	},
	{
		CurrencyCode: 'ZAR',
		CurrencyName: 'South African Rand',
	},
];

export const COUNTRIES = [
	{
		CountryName: 'Afghanistan',
		CountryCode: 'AF',
	},
	{
		CountryName: 'Ăland Islands',
		CountryCode: 'AX',
	},
	{
		CountryName: 'Albania',
		CountryCode: 'AL',
	},
	{
		CountryName: 'Algeria',
		CountryCode: 'DZ',
	},
	{
		CountryName: 'American Samoa',
		CountryCode: 'AS',
	},
	{
		CountryName: 'Andorra',
		CountryCode: 'AD',
	},
	{
		CountryName: 'Angola',
		CountryCode: 'AO',
	},
	{
		CountryName: 'Anguilla',
		CountryCode: 'AI',
	},
	{
		CountryName: 'Antarctica',
		CountryCode: 'AQ',
	},
	{
		CountryName: 'Antigua and Barbuda',
		CountryCode: 'AG',
	},
	{
		CountryName: 'Argentina',
		CountryCode: 'AR',
	},
	{
		CountryName: 'Armenia',
		CountryCode: 'AM',
	},
	{
		CountryName: 'Aruba',
		CountryCode: 'AW',
	},
	{
		CountryName: 'Australia',
		CountryCode: 'AU',
	},
	{
		CountryName: 'Austria',
		CountryCode: 'AT',
	},
	{
		CountryName: 'Azerbaijan',
		CountryCode: 'AZ',
	},
	{
		CountryName: 'Bahamas',
		CountryCode: 'BS',
	},
	{
		CountryName: 'Bahrain',
		CountryCode: 'BH',
	},
	{
		CountryName: 'Bangladesh',
		CountryCode: 'BD',
	},
	{
		CountryName: 'Barbados',
		CountryCode: 'BB',
	},
	{
		CountryName: 'Belarus',
		CountryCode: 'BY',
	},
	{
		CountryName: 'Belgium',
		CountryCode: 'BE',
	},
	{
		CountryName: 'Belize',
		CountryCode: 'BZ',
	},
	{
		CountryName: 'Benin',
		CountryCode: 'BJ',
	},
	{
		CountryName: 'Bermuda',
		CountryCode: 'BM',
	},
	{
		CountryName: 'Bhutan',
		CountryCode: 'BT',
	},
	{
		CountryName: 'Bolivia, Plurinational State of',
		CountryCode: 'BO',
	},
	{
		CountryName: 'Bonaire, Sint Eustatius and Saba',
		CountryCode: 'BQ',
	},
	{
		CountryName: 'Bosnia and Herzegovina',
		CountryCode: 'BA',
	},
	{
		CountryName: 'Botswana',
		CountryCode: 'BW',
	},
	{
		CountryName: 'Bouvet Island',
		CountryCode: 'BV',
	},
	{
		CountryName: 'Brazil',
		CountryCode: 'BR',
	},
	{
		CountryName: 'British Indian Ocean Territory',
		CountryCode: 'IO',
	},
	{
		CountryName: 'Brunei Darussalam',
		CountryCode: 'BN',
	},
	{
		CountryName: 'Bulgaria',
		CountryCode: 'BG',
	},
	{
		CountryName: 'Burkina Faso',
		CountryCode: 'BF',
	},
	{
		CountryName: 'Burundi',
		CountryCode: 'BI',
	},
	{
		CountryName: 'Cambodia',
		CountryCode: 'KH',
	},
	{
		CountryName: 'Cameroon',
		CountryCode: 'CM',
	},
	{
		CountryName: 'Canada',
		CountryCode: 'CA',
	},
	{
		CountryName: 'Republic of Cabo Verde',
		CountryCode: 'CV',
	},
	{
		CountryName: 'Cayman Islands',
		CountryCode: 'KY',
	},
	{
		CountryName: 'Central African Republic',
		CountryCode: 'CF',
	},
	{
		CountryName: 'Chad',
		CountryCode: 'TD',
	},
	{
		CountryName: 'Chile',
		CountryCode: 'CL',
	},
	{
		CountryName: 'China',
		CountryCode: 'CN',
	},
	{
		CountryName: 'Christmas Island',
		CountryCode: 'CX',
	},
	{
		CountryName: 'Cocos (Keeling) Islands',
		CountryCode: 'CC',
	},
	{
		CountryName: 'Colombia',
		CountryCode: 'CO',
	},
	{
		CountryName: 'Comoros',
		CountryCode: 'KM',
	},
	{
		CountryName: 'Congo',
		CountryCode: 'CG',
	},
	{
		CountryName: 'Congo, the Democratic Republic of the',
		CountryCode: 'CD',
	},
	{
		CountryName: 'Cook Islands',
		CountryCode: 'CK',
	},
	{
		CountryName: 'Costa Rica',
		CountryCode: 'CR',
	},
	{
		CountryName: "Cote d'Ivoire",
		CountryCode: 'CI',
	},
	{
		CountryName: 'Croatia',
		CountryCode: 'HR',
	},
	{
		CountryName: 'Cuba',
		CountryCode: 'CU',
	},
	{
		CountryName: 'Curacao',
		CountryCode: 'CW',
	},
	{
		CountryName: 'Cyprus',
		CountryCode: 'CY',
	},
	{
		CountryName: 'Czech Republic',
		CountryCode: 'CZ',
	},
	{
		CountryName: 'Denmark',
		CountryCode: 'DK',
	},
	{
		CountryName: 'Djibouti',
		CountryCode: 'DJ',
	},
	{
		CountryName: 'Dominica',
		CountryCode: 'DM',
	},
	{
		CountryName: 'Dominican Republic',
		CountryCode: 'DO',
	},
	{
		CountryName: 'Ecuador',
		CountryCode: 'EC',
	},
	{
		CountryName: 'Egypt',
		CountryCode: 'EG',
	},
	{
		CountryName: 'El Salvador',
		CountryCode: 'SV',
	},
	{
		CountryName: 'Equatorial Guinea',
		CountryCode: 'GQ',
	},
	{
		CountryName: 'Eritrea',
		CountryCode: 'ER',
	},
	{
		CountryName: 'Estonia',
		CountryCode: 'EE',
	},
	{
		CountryName: 'Ethiopia',
		CountryCode: 'ET',
	},
	{
		CountryName: 'Falkland Islands (Malvinas)',
		CountryCode: 'FK',
	},
	{
		CountryName: 'Fiji',
		CountryCode: 'FJ',
	},
	{
		CountryName: 'Finland',
		CountryCode: 'FI',
	},
	{
		CountryName: 'France',
		CountryCode: 'FR',
	},
	{
		CountryName: 'French Guiana',
		CountryCode: 'GF',
	},
	{
		CountryName: 'French Polynesia',
		CountryCode: 'PF',
	},
	{
		CountryName: 'French Southern Territories',
		CountryCode: 'TF',
	},
	{
		CountryName: 'Gabon',
		CountryCode: 'GA',
	},
	{
		CountryName: 'Gambia',
		CountryCode: 'GM',
	},
	{
		CountryName: 'Georgia',
		CountryCode: 'GE',
	},
	{
		CountryName: 'Germany',
		CountryCode: 'DE',
	},
	{
		CountryName: 'Ghana',
		CountryCode: 'GH',
	},
	{
		CountryName: 'Greece',
		CountryCode: 'EL',
	},
	{
		CountryName: 'Grenada',
		CountryCode: 'GD',
	},
	{
		CountryName: 'Guadeloupe',
		CountryCode: 'GP',
	},
	{
		CountryName: 'Guam',
		CountryCode: 'GU',
	},
	{
		CountryName: 'Guatemala',
		CountryCode: 'GT',
	},
	{
		CountryName: 'Guernsey',
		CountryCode: 'GG',
	},
	{
		CountryName: 'Guinea',
		CountryCode: 'GN',
	},
	{
		CountryName: 'Guinea-Bissau',
		CountryCode: 'GW',
	},
	{
		CountryName: 'Guyana',
		CountryCode: 'GY',
	},
	{
		CountryName: 'Haiti',
		CountryCode: 'HT',
	},
	{
		CountryName: 'Heard Island and McDonald Islands',
		CountryCode: 'HM',
	},
	{
		CountryName: 'Holy See (Vatican City State)',
		CountryCode: 'VA',
	},
	{
		CountryName: 'Honduras',
		CountryCode: 'HN',
	},
	{
		CountryName: 'Hong Kong',
		CountryCode: 'HK',
	},
	{
		CountryName: 'Hungary',
		CountryCode: 'HU',
	},
	{
		CountryName: 'Iceland',
		CountryCode: 'IS',
	},
	{
		CountryName: 'India',
		CountryCode: 'IN',
	},
	{
		CountryName: 'Indonesia',
		CountryCode: 'ID',
	},
	{
		CountryName: 'Iran, Islamic Republic of',
		CountryCode: 'IR',
	},
	{
		CountryName: 'Iraq',
		CountryCode: 'IQ',
	},
	{
		CountryName: 'Ireland',
		CountryCode: 'IE',
	},
	{
		CountryName: 'Isle of Man',
		CountryCode: 'IM',
	},
	{
		CountryName: 'Israel',
		CountryCode: 'IL',
	},
	{
		CountryName: 'Italy',
		CountryCode: 'IT',
	},
	{
		CountryName: 'Jamaica',
		CountryCode: 'JM',
	},
	{
		CountryName: 'Japan',
		CountryCode: 'JP',
	},
	{
		CountryName: 'Jersey',
		CountryCode: 'JE',
	},
	{
		CountryName: 'Jordan',
		CountryCode: 'JO',
	},
	{
		CountryName: 'Kazakhstan',
		CountryCode: 'KZ',
	},
	{
		CountryName: 'Kenya',
		CountryCode: 'KE',
	},
	{
		CountryName: 'Kiribati',
		CountryCode: 'KI',
	},
	{
		CountryName: "Korea, Democratic People's Republic of",
		CountryCode: 'KP',
	},
	{
		CountryName: 'Korea, Republic of',
		CountryCode: 'KR',
	},
	{
		CountryName: 'Kuwait',
		CountryCode: 'KW',
	},
	{
		CountryName: 'Kyrgyzstan',
		CountryCode: 'KG',
	},
	{
		CountryName: "Lao People's Democratic Republic",
		CountryCode: 'LA',
	},
	{
		CountryName: 'Latvia',
		CountryCode: 'LV',
	},
	{
		CountryName: 'Lebanon',
		CountryCode: 'LB',
	},
	{
		CountryName: 'Lesotho',
		CountryCode: 'LS',
	},
	{
		CountryName: 'Liberia',
		CountryCode: 'LR',
	},
	{
		CountryName: 'Libya',
		CountryCode: 'LY',
	},
	{
		CountryName: 'Liechtenstein',
		CountryCode: 'LI',
	},
	{
		CountryName: 'Lithuania',
		CountryCode: 'LT',
	},
	{
		CountryName: 'Luxembourg',
		CountryCode: 'LU',
	},
	{
		CountryName: 'Macao',
		CountryCode: 'MO',
	},
	{
		CountryName: 'Macedonia',
		CountryCode: 'MK',
	},
	{
		CountryName: 'Madagascar',
		CountryCode: 'MG',
	},
	{
		CountryName: 'Malawi',
		CountryCode: 'MW',
	},
	{
		CountryName: 'Malaysia',
		CountryCode: 'MY',
	},
	{
		CountryName: 'Maldives',
		CountryCode: 'MV',
	},
	{
		CountryName: 'Mali',
		CountryCode: 'ML',
	},
	{
		CountryName: 'Malta',
		CountryCode: 'MT',
	},
	{
		CountryName: 'Marshall Islands',
		CountryCode: 'MH',
	},
	{
		CountryName: 'Martinique',
		CountryCode: 'MQ',
	},
	{
		CountryName: 'Mauritania',
		CountryCode: 'MR',
	},
	{
		CountryName: 'Mauritius',
		CountryCode: 'MU',
	},
	{
		CountryName: 'Mayotte',
		CountryCode: 'YT',
	},
	{
		CountryName: 'Mexico',
		CountryCode: 'MX',
	},
	{
		CountryName: 'Micronesia, Federated States of',
		CountryCode: 'FM',
	},
	{
		CountryName: 'Moldova, Republic of',
		CountryCode: 'MD',
	},

	{
		CountryName: 'Mongolia',
		CountryCode: 'MN',
	},
	{
		CountryName: 'Montenegro',
		CountryCode: 'ME',
	},
	{
		CountryName: 'Montserrat',
		CountryCode: 'MS',
	},
	{
		CountryName: 'Morocco',
		CountryCode: 'MA',
	},
	{
		CountryName: 'Mozambique',
		CountryCode: 'MZ',
	},
	{
		CountryName: 'Myanmar',
		CountryCode: 'MM',
	},
	{
		CountryName: 'Namibia',
		CountryCode: 'NA',
	},
	{
		CountryName: 'Nauru',
		CountryCode: 'NR',
	},
	{
		CountryName: 'Nepal',
		CountryCode: 'NP',
	},
	{
		CountryName: 'Netherlands',
		CountryCode: 'NL',
	},
	{
		CountryName: 'New Caledonia',
		CountryCode: 'NC',
	},
	{
		CountryName: 'New Zealand',
		CountryCode: 'NZ',
	},
	{
		CountryName: 'Nicaragua',
		CountryCode: 'NI',
	},
	{
		CountryName: 'Niger',
		CountryCode: 'NE',
	},
	{
		CountryName: 'Nigeria',
		CountryCode: 'NG',
	},
	{
		CountryName: 'Niue',
		CountryCode: 'NU',
	},
	{
		CountryName: 'Norfolk Island',
		CountryCode: 'NF',
	},
	{
		CountryName: 'Northern Mariana Islands',
		CountryCode: 'MP',
	},
	{
		CountryName: 'Norway',
		CountryCode: 'NO',
	},
	{
		CountryName: 'Oman',
		CountryCode: 'OM',
	},
	{
		CountryName: 'Pakistan',
		CountryCode: 'PK',
	},
	{
		CountryName: 'Palau',
		CountryCode: 'PW',
	},
	{
		CountryName: 'Palestine, State of',
		CountryCode: 'PS',
	},
	{
		CountryName: 'Panama',
		CountryCode: 'PA',
	},
	{
		CountryName: 'Papua New Guinea',
		CountryCode: 'PG',
	},
	{
		CountryName: 'Paraguay',
		CountryCode: 'PY',
	},
	{
		CountryName: 'Peru',
		CountryCode: 'PE',
	},
	{
		CountryName: 'Philippines',
		CountryCode: 'PH',
	},
	{
		CountryName: 'Pitcairn',
		CountryCode: 'PN',
	},
	{
		CountryName: 'Poland',
		CountryCode: 'PL',
	},
	{
		CountryName: 'Portugal',
		CountryCode: 'PT',
	},
	{
		CountryName: 'Puerto Rico',
		CountryCode: 'PR',
	},
	{
		CountryName: 'Qatar',
		CountryCode: 'QA',
	},
	{
		CountryName: 'RĂŠunion',
		CountryCode: 'RE',
	},
	{
		CountryName: 'Romania',
		CountryCode: 'RO',
	},
	{
		CountryName: 'Russian Federation',
		CountryCode: 'RU',
	},
	{
		CountryName: 'Rwanda',
		CountryCode: 'RW',
	},
	{
		CountryName: 'Saint BarthĂŠlemy',
		CountryCode: 'BL',
	},
	{
		CountryName: 'Saint Helena, Ascension and Tristan da Cunha',
		CountryCode: 'SH',
	},
	{
		CountryName: 'Saint Kitts and Nevis',
		CountryCode: 'KN',
	},
	{
		CountryName: 'Saint Lucia',
		CountryCode: 'LC',
	},
	{
		CountryName: 'Saint Martin (French part)',
		CountryCode: 'MF',
	},
	{
		CountryName: 'Saint Pierre and Miquelon',
		CountryCode: 'PM',
	},
	{
		CountryName: 'Saint Vincent and the Grenadines',
		CountryCode: 'VC',
	},
	{
		CountryName: 'Samoa',
		CountryCode: 'WS',
	},
	{
		CountryName: 'Sao Tome and Principe',
		CountryCode: 'ST',
	},
	{
		CountryName: 'Saudi Arabia',
		CountryCode: 'SA',
	},
	{
		CountryName: 'Senegal',
		CountryCode: 'SN',
	},
	{
		CountryName: 'Serbia',
		CountryCode: 'RS',
	},
	{
		CountryName: 'Seychelles',
		CountryCode: 'SC',
	},
	{
		CountryName: 'Sierra Leone',
		CountryCode: 'SL',
	},
	{
		CountryName: 'Singapore',
		CountryCode: 'SG',
	},
	{
		CountryName: 'Sint Maarten (Dutch part)',
		CountryCode: 'SX',
	},
	{
		CountryName: 'Slovakia',
		CountryCode: 'SK',
	},
	{
		CountryName: 'Slovenia',
		CountryCode: 'SI',
	},
	{
		CountryName: 'Solomon Islands',
		CountryCode: 'SB',
	},
	{
		CountryName: 'Somalia',
		CountryCode: 'SO',
	},
	{
		CountryName: 'South Africa',
		CountryCode: 'ZA',
	},
	{
		CountryName: 'South Georgia and the South Sandwich Islands',
		CountryCode: 'GS',
	},
	{
		CountryName: 'South Sudan',
		CountryCode: 'SS',
	},
	{
		CountryName: 'Spain',
		CountryCode: 'ES',
	},
	{
		CountryName: 'Sri Lanka',
		CountryCode: 'LK',
	},
	{
		CountryName: 'Sudan',
		CountryCode: 'SD',
	},
	{
		CountryName: 'Suriname',
		CountryCode: 'SR',
	},
	{
		CountryName: 'Svalbard and Jan Mayen',
		CountryCode: 'SJ',
	},
	{
		CountryName: 'Kingdom of Eswatini',
		CountryCode: 'SZ',
	},
	{
		CountryName: 'Sweden',
		CountryCode: 'SE',
	},
	{
		CountryName: 'Switzerland',
		CountryCode: 'CH',
	},
	{
		CountryName: 'Syrian Arab Republic',
		CountryCode: 'SY',
	},
	{
		CountryName: 'Taiwan, Province of China',
		CountryCode: 'TW',
	},
	{
		CountryName: 'Tajikistan',
		CountryCode: 'TJ',
	},
	{
		CountryName: 'Tanzania, United Republic of',
		CountryCode: 'TZ',
	},
	{
		CountryName: 'Thailand',
		CountryCode: 'TH',
	},
	{
		CountryName: 'Timor-Leste',
		CountryCode: 'TL',
	},
	{
		CountryName: 'Togo',
		CountryCode: 'TG',
	},
	{
		CountryName: 'Tokelau',
		CountryCode: 'TK',
	},
	{
		CountryName: 'Tonga',
		CountryCode: 'TO',
	},
	{
		CountryName: 'Trinidad and Tobago',
		CountryCode: 'TT',
	},
	{
		CountryName: 'Tunisia',
		CountryCode: 'TN',
	},
	{
		CountryName: 'Turkey',
		CountryCode: 'TR',
	},
	{
		CountryName: 'Turkmenistan',
		CountryCode: 'TM',
	},
	{
		CountryName: 'Turks and Caicos Islands',
		CountryCode: 'TC',
	},
	{
		CountryName: 'Tuvalu',
		CountryCode: 'TV',
	},
	{
		CountryName: 'Uganda',
		CountryCode: 'UG',
	},
	{
		CountryName: 'Ukraine',
		CountryCode: 'UA',
	},
	{
		CountryName: 'United Arab Emirates',
		CountryCode: 'AE',
	},
	{
		CountryName: 'United Kingdom',
		CountryCode: 'GB',
	},
	{
		CountryName: 'United States',
		CountryCode: 'US',
	},
	{
		CountryName: 'United States Minor Outlying Islands',
		CountryCode: 'UM',
	},
	{
		CountryName: 'Uruguay',
		CountryCode: 'UY',
	},
	{
		CountryName: 'Uzbekistan',
		CountryCode: 'UZ',
	},
	{
		CountryName: 'Vanuatu',
		CountryCode: 'VU',
	},
	{
		CountryName: 'Venezuela, Bolivarian Republic of',
		CountryCode: 'VE',
	},
	{
		CountryName: 'Viet Nam',
		CountryCode: 'VN',
	},
	{
		CountryName: 'Virgin Islands, British',
		CountryCode: 'VG',
	},
	{
		CountryName: 'Virgin Islands, U.S.',
		CountryCode: 'VI',
	},
	{
		CountryName: 'Wallis and Futuna',
		CountryCode: 'WF',
	},
	{
		CountryName: 'Western Sahara',
		CountryCode: 'EH',
	},
	{
		CountryName: 'Yemen',
		CountryCode: 'YE',
	},
	{
		CountryName: 'Zambia',
		CountryCode: 'ZM',
	},
	{
		CountryName: 'Zimbabwe',
		CountryCode: 'ZW',
	},
	{
		CountryName: 'Canary Islands',
		CountryCode: 'IC',
	},
	{
		CountryName: 'Kosovo',
		CountryCode: 'XK',
	},
	{
		CountryName: 'Gibraltar',
		CountryCode: 'GI',
	},
	{
		CountryName: 'Monaco',
		CountryCode: 'MC',
	},
	{
		CountryName: 'Greenland',
		CountryCode: 'GL',
	},
	{
		CountryName: 'Faroe Islands',
		CountryCode: 'FO',
	},
	{
		CountryName: 'San Marino',
		CountryCode: 'SM',
	},
];

export const COUNTRIES_WITH_VAT_EU = [
	{
		CountryName: 'Austria',
		CountryCode: 'AT',
	},
	{
		CountryName: 'Belgium',
		CountryCode: 'BE',
	},
	{
		CountryName: 'Bulgaria',
		CountryCode: 'BG',
	},
	{
		CountryName: 'Croatia',
		CountryCode: 'HR',
	},
	{
		CountryName: 'Cyprus',
		CountryCode: 'CY',
	},
	{
		CountryName: 'Czech Republic',
		CountryCode: 'CZ',
	},
	{
		CountryName: 'Denmark',
		CountryCode: 'DK',
	},
	{
		CountryName: 'Estonia',
		CountryCode: 'EE',
	},
	{
		CountryName: 'Finland',
		CountryCode: 'FI',
	},
	{
		CountryName: 'France',
		CountryCode: 'FR',
	},
	{
		CountryName: 'Germany',
		CountryCode: 'DE',
	},
	{
		CountryName: 'Greece',
		CountryCode: 'EL',
	},
	{
		CountryName: 'Hungary',
		CountryCode: 'HU',
	},
	{
		CountryName: 'Ireland',
		CountryCode: 'IE',
	},
	{
		CountryName: 'Italy',
		CountryCode: 'IT',
	},
	{
		CountryName: 'Latvia',
		CountryCode: 'LV',
	},
	{
		CountryName: 'Lithuania',
		CountryCode: 'LT',
	},
	{
		CountryName: 'Luxembourg',
		CountryCode: 'LU',
	},
	{
		CountryName: 'Malta',
		CountryCode: 'MT',
	},
	{
		CountryName: 'Netherlands',
		CountryCode: 'NL',
	},
	{
		CountryName: 'Poland',
		CountryCode: 'PL',
	},
	{
		CountryName: 'Portugal',
		CountryCode: 'PT',
	},
	{
		CountryName: 'Romania',
		CountryCode: 'RO',
	},
	{
		CountryName: 'Slovakia',
		CountryCode: 'SK',
	},
	{
		CountryName: 'Slovenia',
		CountryCode: 'SI',
	},
	{
		CountryName: 'Spain',
		CountryCode: 'ES',
	},
	{
		CountryName: 'Sweden',
		CountryCode: 'SE',
	},
	{
		CountryName: 'Isle of Man',
		CountryCode: 'IM',
	},
	// {
	// 	CountryName: 'Canary Islands',
	// 	CountryCode: 'IC'
	// },
	// {
	// 	CountryName: 'Kosovo',
	// 	CountryCode: 'XK'
	// },
	// {
	// 	CountryName: 'Gibraltar',
	// 	CountryCode: 'GI'
	// },
	// {
	// 	CountryName: 'Monaco',
	// 	CountryCode: 'MC'
	// },
	// {
	// 	CountryName: 'Greenland',
	// 	CountryCode: 'GL'
	// },
	// {
	// 	CountryName: 'Faroe Islands',
	// 	CountryCode: 'FO'
	// },
	// {
	// 	CountryName: 'San Marino',
	// 	CountryCode: 'SM'
	// }
];

export const NEW_ROOM = 'New Room';
export const encryptionKeyDefault = '00000000000000000000000000000000';

//this will be used for inclusion to enable disable bluetooth and access points if not included inside this constant;
export const GEN_1_DEVICES = [
	'SHPLG-1',
	'SHPLG-S',
	'SHPLG-U1',
	'SHPLG-UK1',
	'SHPLG-AU1',
	'SHPLG2-1',
	'SHSW-1',
	'SHSW-1S',
	'SHSW-PM',
	'SHSW-L',
	'SHSW-21',
	'SHSW-22',
	'SHSW-25',
	'SHSW-44',
	'SHAIR-1',
	'SHUNI-1',
	'SHEM',
	'SHEM-3',
	'SHSEN-1',
	'SHGS-1',
	'SHMOS-01',
	'SHMOS-02',
	'SHSM-01',
	'SHHT-1',
	'SHDW-1',
	'SHDW-2',
	'SHWT-1',
	'SHCL-255',
	'SHBLB-01',
	'SHRGBWW-01',
	'SHRGBW2',
	'SH2LED-1',
	'SHDM-1',
	'SHDM-2',
	'SHDIMW-1',
	'SHVIN-1',
	'SHCB-1',
	'SHBTN-1',
	'SHBTN-2',
	'SHIX-3',
	'SHTRV-01',
	'SHSPOT-1',
	'SHBDUO-1',
	'SHIX3-1',
	'SHBLB-1',
];

export const INCLUSION_HIDE_BLUETOOTH_SETTINGS = [
	'SNGW-BT01',
	'S3GW-1DBT001',
	'S3GW-0D4G0EU',
	'S3SN-0082A',
]; //bluetooth gateway for now (incl. Alarm Bridge)

export const INCLUSION_HIDE_AP_DISABLE = [
	'SAWD-0A1XX10EU1',
	'SAWD-1A1XX10EU1',
	'SAWD-2A1XX10EU1',
	'SAWD-3A2XE10EU2',
	'SAWD-3A1XE10EU2',
	'SAWD-4A1XE10US0',
	'SAWD-5A1XX10EU0',
	'SAWD-6A1XX10EU0',
	'SAWD-0A1XX10EU2',
	'SAWD-6A0XX0EU0',
]; //wall display devices

export const WALL_DISPLAYS_WITHOUT_INTERNAL_SENSOR = [
	'SAWD-3A2XE10EU2', //ShellyWallDisplayXL old model
	'SAWD-3A1XE10EU2', //ShellyWallDisplayXL new model
	'SAWD-4A1XE10US0', //ShellyWallDisplayXL US
	'SAWD-5A1XX10EU0', //ShellyWallDisplayX2 Smatek
	'SAWD-6A1XX10EU0', //ShellyWallDisplayX1i
	'SAWD-6A0XX0EU0', //ShellyWallDisplay D1
];

//#region password

export const MIN_PASSWORD_LENGTH = 6;

//#endregion

//#region premium, non-premium or been premium
export const PREMIUM_WIDGETS_LIMIT = 80;
export const NON_PREMIUM_WIDGETS_LIMIT = 40;

export const PREMIUM_DASH_TABS_LIMIT = 20;
export const NON_PREMIUM_DASH_TABS_LIMIT = 5;

export const MAX_OWNED_HOMES = 5;

//#endregion

//#region Thermostats
export const MAX_TEMPERATURE_LIMIT = {
	C: 2000,
	F: 3632,
};
export const MIN_TEMPERATURE_LIMIT = {
	C: -273,
	F: -459,
};

//#endregion

//#region change timestamp for privacy policy and general terms and conditions in seconds
export const CHANGE_DATE = {
	PP: 1781568000,
	GTC: 1781568000,
	DA: 1757635200,
	APP_ICON_MODAL: 1766404800,
	AI_PP: 1772236800, // 27 Feb 2026
};

//#endregion

//#region APP VERSIONS PROMO
// Below are used only in prod and staging
export const APP_VERSION_FOR_PROMO_BASIC = '3.117.20'; // this is the version in which to show the promo basic modal
export const APP_VERSION_FOR_PROMO_PREMIUM = '3.117.20'; // this is the version in which to show the promo premium modal

//#region AI Model
export const MAX_AI_MODEL_LIMIT = 10;
export const AI_PROMPT_LIMIT_PREMIUM = 50;

export const AI_FAILURE_REASONS = {
	1: 'lower_consumption',
	2: 'higher_consumption',
	3: 'longer_sequence',
	4: 'shorter_sequence',
};
//#endregion

//#region Promotion Dates
export const PROMOTIONS = {
	PREMIUM_FEATURES: {
		START_DATE: new Date('2025-02-17T00:00:00').getTime(),
		END_DATE: new Date('2025-03-01T00:00:00').getTime(),
	},
	ANNUAL_SURVEY: {
		START_DATE: new Date('2025-01-20T00:00:00').getTime(),
		END_DATE: new Date('2025-02-17T00:00:00').getTime(),
	},
	GEN_1_REPLACEMENT: {
		START_DATE: new Date('2026-02-02T00:00:00').getTime(),
		END_DATE: new Date('2026-04-30T23:59:59').getTime(),
	},
	BLACK_FRIDAY: {
		INITIALIZATION_DATE: new Date('2024-11-25T00:00:00').getTime(),
		START_DATE: new Date('2024-11-28T00:00:00').getTime(),
		END_DATE: new Date('2024-12-04T00:00:00').getTime(),
	},
	BLACK_FRIDAY_PHASE_1: {
		START_DATE: new Date('2025-11-13T00:00:00').getTime(),
		END_DATE: new Date('2025-11-20T10:00:00').getTime(),
	},
	BLACK_FRIDAY_PHASE_2: {
		START_DATE: new Date('2025-11-20T10:00:00').getTime(),
		END_DATE: new Date('2025-12-03T00:00:00').getTime(),
	},
	EARTH_DAY: {
		START_DATE: new Date('2025-04-16T00:00:00').getTime(),
		END_DATE: new Date('2025-04-22T20:00:00').getTime(),
	},
	SPIN_WHEEL: {
		START_DATE: new Date('2025-06-23T00:00:00').getTime(),
		END_DATE: new Date('2025-07-01T00:00:00').getTime(),
	},
	SMART_HOME_CHALLENGE: {
		START_DATE: new Date('2025-07-01T00:00:00').getTime(),
		END_DATE: new Date('2025-07-16T00:00:00').getTime(),
	},
	SHELLY_BIRTHDAY_TEASER: {
		START_DATE: new Date('2025-07-17T00:00:00').getTime(),
		END_DATE: new Date('2025-07-24T00:00:00').getTime(),
	},
	SHELLY_BIRTHDAY_CAMPAIGN: {
		START_DATE: new Date('2025-07-24T00:00:00').getTime(),
		END_DATE: new Date('2025-07-31T00:00:00').getTime(),
	},
	ENERGY_PRICE_SETUP: {
		START_DATE: new Date('2025-01-01T00:00:00').getTime(),
		END_DATE: new Date('2026-12-31T23:59:59').getTime(),
	},
	ANNUAL_SURVEY_2026: {
		START_DATE: new Date('2026-01-19T11:00:00').getTime(),
		END_DATE: new Date('2026-02-09T00:00:00').getTime(),
	},
	THIRTY_MILLION_DEVICES: {
		START_DATE: new Date('2026-02-25T00:00:00').getTime(),
		END_DATE: new Date('2026-03-03T23:59:59').getTime(),
	},
	XL_X2_FLASH_DEAL: {
		START_DATE: new Date('2026-03-30T00:00:00').getTime(),
		END_DATE: new Date('2026-03-31T23:59:59').getTime(),
	},
	SPRING_DEALS_2026: {
		START_DATE: new Date('2026-04-22T09:00:00').getTime(),
		END_DATE: new Date('2026-04-28T23:59:59').getTime(),
	},
	SMART_HOME_CHALLENGE_2026: {
		START_DATE: new Date('2026-05-18T10:00:00').getTime(),
		END_DATE: new Date('2026-06-03T23:59:59').getTime(),
	},
	WALL_DISPLAY_FLASH_SALE_2: {
		START_DATE: new Date('2026-06-26T09:00:00').getTime(),
		END_DATE: new Date('2026-06-28T23:59:59').getTime(),
	},
	SHELLY_BIRTHDAY_2026: {
		START_DATE: new Date('2026-07-22T00:00:00').getTime(),
		END_DATE: new Date('2026-07-29T23:59:59').getTime(),
	},
};
//#endregion

//#region BLU Settings
// These are the bluetooth settings that need device information to show the proper status before enabling/disabling.
export const BLU_SETTINGS_THAT_NEED_STATUS = [
	{
		setting: 'measurement_movement',
		title_key: 'sub_settings_title_measurement_movement',
		text_key: 'text_set_accelerometer_on_movement_vibration',
		enable_command: 'enableMeasureVibration',
		disable_command: 'disableMeasureVibration',
		bulk_value: 'measureVibration',
	},
	{
		setting: 'beacon_mode',
		title_key: 'sub_settings_title_beacon_mode',
		enable_command: 'enableBeacon',
		disable_command: 'disableBeacon',
		bulk_value: 'beaconEnabled',
	},
	{
		setting: 'buzzer',
		title_key: 'sub_settings_title_buzzer',
		enable_command: 'enableBuzzer',
		disable_command: 'disableBuzzer',
		bulk_value: 'buzzerEnabled',
	},
	{
		setting: 'motion_led',
		title_key: 'sub_settings_title_motion_led',
		text_key: 'text_motion_led',
		enable_command: 'enableMotionLed',
		disable_command: 'disableMotionLed',
		bulk_value: 'motionLedEnabled',
	},
	{
		setting: 'security',
		title_key: 'sub_settings_title_security',
		info_key: 'sub_settings_info_security',
		enable_command: 'encrypt',
		disable_command: 'decrypt',
		bulk_value: 'encrypted',
	},
	{
		setting: 'invert_display',
		title_key: 'sub_settings_title_invert_display',
		info_key: 'sub_settings_info_invert_display',
		enable_command: 'enableInvertDisplay',
		disable_command: 'disableInvertDisplay',
		bulk_value: 'invertDisplayEnabled',
	},
	{
		setting: 'fahrenheit_unit',
		title_key: 'sub_settings_title_fahrenheit_unit',
		info_key: 'sub_settings_info_fahrenheit_unit',
		enable_command: 'enableFahrenheit',
		disable_command: 'disableFahrenheit',
		bulk_value: 'fahrenheitEnabled',
	},
	{
		setting: 'clock_sync',
		title_key: 'sub_settings_title_clock_sync',
		info_key: 'sub_settings_info_clock_sync',
		enable_command: 'enableClockSync',
		disable_command: 'disableClockSync',
		bulk_value: 'clockSyncEnabled',
	},
	{
		setting: 'power_saver',
		title_key: 'sub_settings_title_power_saver',
		info_key: 'sub_settings_info_power_saver',
		enable_command: 'enablePowerSaver',
		disable_command: 'disablePowerSaver',
		bulk_value: 'powerSaverEnabled',
	},
	{
		setting: 'zigbee',
		title_key: 'sub_settings_title_zigbee',
		info_key: 'sub_settings_info_zegbee',
		enable_command: 'enableZigbee',
		disable_command: 'disableZigbee',
		bulk_value: 'zigbeeEnabled',
	},
];
//#endregion

export const BLU_DEVICES_SHOW_MAC = [
	'SNGW-BT01', // BLU Gateway
	'S3GW-1DBT001', // BLU Gateway Gen 3
	'SBTR-001AEU', // BLU TRV
	'S3SN-0082A', // Alarm Bridge (WiFi+BLE, Gen2)
];

export const ACTIVE_POWER_WEBHOOK_SUPPORTED_DEVICES = [
	'S4PL-00416EU', // Shelly Power Strip 4 Gen4
	'S4PL-00114EU', // Shelly Plug C Gen4
	'SNPL-00110EU', // Shelly Plus Plug S
	'SNPL-00210EU', // Shelly Plus Plug S
	'SNPL-00112EU', // Shelly Plus Plug S
	'SNPL-10112EU', // Shelly AZ Plug
	'SNPL-00112UK', // Shelly Plus Plug UK
	'SNPL-00110IT', // Shelly Plus Plug IT 10A
	'SNPL-00116IT', // Shelly Plus Plug IT 16A
];

//#region Experimental Features
export const SCRIPT_SCENES_DISCORD_LINK =
	'https://discord.com/channels/472853585311301663/1495687090883657769/threads/1495687704413863946';
export const AI_SCENE_ASSISTANT_DISCORD_LINK = 'https://discord.gg/KXsqqR9wKy';
export const MATH_IN_SCENES_DISCORD_LINK =
	'https://discord.com/channels/472853585311301663/1495687090883657769/threads/1506012561743810630';
export const NEW_APP_LAYOUT_DISCORD_LINK =
	'https://discord.com/channels/472853585311301663/1495687090883657769/threads/1495687406173814856';
export const CLONE_SETTINGS_DISCORD_LINK =
	'https://discord.com/channels/472853585311301663/1495687090883657769/threads/1506012612817588316';
export const NET_METERING_DISCORD_LINK =
	'https://discord.com/channels/472853585311301663/1495687090883657769/threads/1506012677632164033';
export const PV_SETUP_DISCORD_LINK =
	'https://discord.com/channels/472853585311301663/1495687090883657769/threads/1506012720057553039';

export const FIVE_DAYS_MS = 5 * 24 * 60 * 60 * 1000;

export const STORAGE_KEY = 'experimental_feature_feedback_reminders';
//#endregion

//#region LocalStorage keys
export const CURRENT_UNIT_ID_KEY = 'currentUnitId';
export const WHATS_NEW_SEEN_KEY = 'whatsNewSeen';
//#endregion

export const DEVICES_WITH_SINGLE_VIEW = [
	'SHSW-1',
	'SHEM',
	'SHEM-3',
	'SNSN-0024X',
	'SPSW-201XE16EU',
	'SNSW-001X8EU',
	'SPSW-003XE16EU',
	'SNSW-001X16EU',
	'S3SW-001X8EU',
	'SPSH-002PE16EU',
	'SPSH-102PE16EU',
	'SNSN-0031Z',
	'S3SN-0082A',
	'S4SN-0031Z',
	'S4SN-0071A',
	'S4SN-0071Z',
	'SPSW-002XE16EU',
	'SHTRV-01',
	'S3SN-0024X',
	'S3SW-001X16EU',
	'S3SW-0A1X1EUL',
	'S3SW-0A1X5US',
	'S3SW-0A2X4EUL',
	'S4SN-0A24X',
	'S4SN-0D24X',
	'S4SW-001X8EU',
	'S4SW-001X16EU',
	'SPCB-01VENEU',
	'SPCB-02VENEU',
	'SPCB-03VENEU',
	'SPCB-04VENEU',
	'S3SH-0A2P4EU',
	'S3GW-1DBT001',
	'SBTR-001AEU',
	'S3XT-0S',
	'SMSN-0031ZL',
	'S3MX-0A',
	'S0CC-0A8PME6WW0',
	'SHBDUO-1',
	'SHBLB-1',
	'SHCB-1',
	'SHDM-2',
	'SHVIN-1',
	'SNDC-0D4P10WW',
	'SPDC-0D5PE16EU',
	'SPDM-001PE01EU',
	'SPDM-002PE01EU',
	'S3BL-C010007AEU',
	'S3BL-D010009AEU',
	'S3DM-0010WW',
	'S3DM-0A101WWL',
	'S3DM-0A1WW',
	'SPCC-001PE10EU',
	'S4DM-0A101WWL',
	'S4DM-0A102US',
	'S4PB-00CU000002',
	'virtual-group',
	'bthome-device',
	'SNDM-00100WW',
	'S4EM-001PXCEU16',
	'SPEM-002CEBEU50',
	'SPEM-003CEBEU',
	'SPEM-003CEBEU63',
	'SPEM-003CEBEU400',
	'SPEM-003REBEU2000',
	'S3EM-002CXCEU',
	'S3EM-003CXCEU63',
	'S4EM-001PXCEU16',
	'S4EM-001CXCEU63',
	'S4EM-002CXCEU',
	'S4EM-003RXCEU63',
	'S4PB-06A7000101',
	'SPSW-001XE16EU',
	'SHRGBW2',
	'S1CM-0DXW00',
	'SACM-0A0XX0EU0',
];

/**
 * Devices that should always default to advanced view (single view = advanced).
 * These devices are also in DEVICES_WITH_SINGLE_VIEW to hide view switching.
 */
export const ADVANCED_ONLY_DEVICES: string[] = ['SPSW-001XE16EU'];

/**
 * Devices that should hide view switching for specific modes.
 * Key: device type, Value: array of modes where view switching should be hidden
 */
export const DEVICES_WITH_MODE_RESTRICTED_VIEW: Record<string, string[]> = {
	'SHSW-21': ['roller'],
	'SHSW-25': ['roller'],
	'SPSW-002PE16EU': ['roller'],
	'SPSW-102PE16EU': ['roller'],
	'SPSW-202PE16EU': ['roller'],
	'SPSW-202PE12UL': ['roller'],
	'SNSW-002P16EU': ['roller'],
	'SNSW-102P16EU': ['roller'],
	'S3SW-002P16EU': ['roller'],
	'S4SW-002P16EU': ['roller'],
	'SPSW-003XE16EU': ['emeter'],
};

/**
 * Predefined icon groups used in the icon search/selection modal.
 * Each group contains a label and a list of FontAwesome icon class strings
 * covering common smart home categories (rooms, appliances, energy, etc.).
 */
export const ICON_GROUPS: { label: { key: string; default: string }; icons: string[] }[] = [
	{
		label: { key: 'label_home_new', default: 'Home' },
		icons: [
			'fa-thin fa-house',
			'fa-thin fa-apartment',
			'fa-thin fa-house-building',
			'fa-thin fa-bed-front',
			'fa-thin fa-bath',
			'fa-thin fa-plate-utensils',
			'fa-thin fa-tv-retro',
			'fa-thin fa-toilet',
		],
	},
	{
		label: { key: 'label_appliance', default: 'Appliance' },
		icons: [
			'fa-thin fa-lightbulb',
			'fa-thin fa-fan',
			'fa-thin fa-air-conditioner',
			'fa-thin fa-oven',
			'fa-thin fa-refrigerator',
			'fa-thin fa-water-ladder',
			'fa-thin fa-gamepad-modern',
			'fa-thin fa-broom',
		],
	},
	{
		label: { key: 'label_energy', default: 'Energy' },
		icons: [
			'fa-thin fa-bolt',
			'fa-thin fa-battery-full',
			'fa-thin fa-sun',
			'fa-thin fa-plug',
			'fa-thin fa-wind',
			'fa-thin fa-leaf',
			'fa-thin fa-utility-pole',
			'fa-thin fa-solar-panel',
		],
	},
	{
		label: { key: 'label_motion', default: 'Motion' },
		icons: [
			'fa-thin fa-person',
			'fa-thin fa-person-running',
			'fa-thin fa-person-running-fast',
			'fa-thin fa-person-walking',
			'fa-thin fa-house-person-leave',
			'fa-thin fa-house-person-return',
			'fa-thin fa-sensor',
			'fa-thin fa-radar',
		],
	},
	{
		label: { key: 'label_temperature', default: 'Temperature' },
		icons: [
			'fa-thin fa-temperature-full',
			'fa-thin fa-temperature-arrow-down',
			'fa-thin fa-temperature-arrow-up',
			'fa-thin fa-temperature-high',
			'fa-thin fa-temperature-snow',
			'fa-thin fa-temperature-sun',
			'fa-thin fa-heat',
			'fa-thin fa-water-temperature',
		],
	},
	{
		label: { key: 'label_humidity', default: 'Humidity' },
		icons: [
			'fa-thin fa-droplet',
			'fa-thin fa-droplet-slash',
			'fa-thin fa-droplet-degree',
			'fa-thin fa-droplet-percent',
			'fa-thin fa-meter-droplet',
			'fa-thin fa-hand-holding-droplet',
			'fa-thin fa-tank-water',
			'fa-thin fa-water',
		],
	},
	{
		label: { key: 'label_vehicle', default: 'Vehicle' },
		icons: [
			'fa-thin fa-car',
			'fa-thin fa-car-side',
			'fa-thin fa-car-battery',
			'fa-thin fa-charging-station',
			'fa-thin fa-car-building',
			'fa-thin fa-garage',
			'fa-thin fa-garage-car',
			'fa-thin fa-square-parking',
		],
	},
];

export const MAX_PAIRED_DEVICES = 20;
export const BLE_PAIRING_TIMEOUT_SEC = 180;
